module.exports = __webpack_public_path__ + "static/media/BlueLight_SagaLogo.b1e05864.png";